module.exports = __webpack_public_path__ + "img/Burst.3d760592.png";